import { Directive, EventEmitter, Input, Output } from '@angular/core';
import { ProfileInfo, ViewProfileType } from 'src/app/interfaces/profile.interface';
import { FullUser } from 'src/app/swagger-api';

@Directive()
export abstract class ViewProfileState implements ViewProfileType {
  @Input({ required: true }) public fields: ProfileInfo[];
  @Input({ required: true }) public displayedName: string;

  @Output() public moreInfoOpen: EventEmitter<ViewProfileType> = new EventEmitter<ViewProfileType>();

  public uncompletedProfile = true;

  public seeMoreInfo(): void {
    this.moreInfoOpen.emit({ fields: this.fields, displayedName: this.displayedName });
  }

  public isProfileUncompleted(user: FullUser): void {
    if (user && user.organization) {
      this.uncompletedProfile = user.profile.location == null;
    } else {
      this.uncompletedProfile = user ? user.user_roles.length === 0 : true;
    }
  }
}
